import * as fragments from 'lib/graphql/fragments';

export const product = `
query product($handle: String!) @inContext(country: ${window.Shopify.country}){
  product(handle: $handle) {
    ${fragments.product}
    options {
      name
      values
    }
  }
}
`;

export const products = `
query($ids: [ID!]!) @inContext(country: ${window.Shopify.country}){
  nodes(ids: $ids) {
    ...on Product {
      ${fragments.product}
    }
  }
}
`;

export const getProductIdByHandle = `
query product($handle: String!) @inContext(country: ${window.Shopify.country}){
  product(handle: $handle) {
    id
  }
}
`;

export const getShadowstixProductById = `
query product($id: ID!) @inContext(country: ${window.Shopify.country}){
  product(id: $id) {
    tags
    variants(first: 1) {
      edges {
        node {
          sku
          title
        }
      }
    }
    shadeDetails: metafield(namespace: "swatch_management", key: "additional_categories") {
      key
      value
    }
  }
}
`;

export const getPropertiesById = `
query($id: ID!) @inContext(country: ${window.Shopify.country}){
  node(id: $id) {
    ...on ProductVariant {
      product {
        metafields(identifiers: [
          { namespace: "general", key: "cart_upsell_bundle" },
          { namespace: "cart_promo", key: "promo_text" },
          { namespace: "cart_promo", key: "link" },
          { namespace: "yotpo", key: "reviews_average" },
        ]) {
          key
          value
          namespace
        }
      }
    }
  }
}
`;

export const quickViewProduct = `
query product($handle: String!) @inContext(country: ${window.Shopify.country}){
  product(handle: $handle) {
    id
    tags
    title
    handle
    description
    productType
    images(first: 1) {
      edges {
        node {
          src: url(transform: { maxWidth: 650 })
        }
      }
    }
    variants(first: 50) {
      edges {
        node {
          id
          title
          price {
            amount
          }
          sku
          compareAtPrice {
            amount
          }
          availableForSale
          image {
            src: url
            altText
          }
        }
      }
    }
  }
}
`;

export const collection = `
query collectionByHandle(
  $handle: String!
  $first: Int!
  $cursor: String
  $order: ProductCollectionSortKeys
  $reverse: Boolean
  ) @inContext(country: ${window.Shopify.country}){
  collection(handle: $handle) {
    products(first: $first, after: $cursor, sortKey: $order, reverse: $reverse) {
      edges {
        cursor
        node {
          ${fragments.product}
        }
      }
    }
  }
}
`;

export const collectionWithVariants = `
query collectionByHandle($handle: String!) @inContext(country: ${window.Shopify.country}){
  collection(handle: $handle) {
    products(first: 100) {
      edges {
        node {
          ${fragments.product}
        }
      }
    }
  }
}
`;

export const collectionForGwp = `
query collectionByHandle(
  $handle: String!
  $first: Int!
  $cursor: String
  ) @inContext(country: ${window.Shopify.country}){
  collection(handle: $handle) {
    products(first: $first, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          variants(first: 50) {
            edges {
              node {
                id
                title
                sourceGWPCollectionItem: metafield(namespace: "accentuate", key: "use_in_gwp") {
                  key
                  value
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const microCollectionMetafields = `
query collectionByHandle($handle: String!) {
  collection(handle: $handle) {
    ${fragments.microCollection}
  }
}
`;

export const productTag = `
query product($handle: String!) {
  product(handle: $handle) {
    tags
  }
}
`;

export const productImageAndUrl = `
query($ids: [ID!]!) {
  nodes(ids: $ids) {
    ...on Product {
      id
      title
      handle
      tags
      images(first: 1) {
        edges {
          node {
            src: url(transform: { maxWidth: 300 })
            altText
          }
        }
      }
    }
  }
}
`;

export const productsTag = `
query($ids: [ID!]!) {
  nodes(ids: $ids) {
    ...on Product {
      tags
    }
  }
}
`;

export const productsTagWithType = `
query($ids: [ID!]!) {
  nodes(ids: $ids) {
    ...on Product {
      tags
      productType
    }
  }
}
`;

export const productsSizes = `
query($ids: [ID!]!) {
  nodes(ids: $ids) {
    ...on Product {
      id
      options {
        id
        name
        values
      }
      variants(first: 50) {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
}
`;

export const productsPrices = `
query($ids: [ID!]!) @inContext(country: ${window.Shopify.country}){
  nodes(ids: $ids) {
    ...on Product {
      variants(first: 50) {
        edges {
          node {
            price {
              amount
            }
            compareAtPrice {
              amount
            }
          }
        }
      }
    }
  }
}
`;

export const productCheckoutInfoById = `
query($ids: [ID!]!) @inContext(country: ${window.Shopify.country}){
  nodes(ids: $ids) {
    ...on Product {
      id
      title
      handle
      tags
      options {
        id
        name
        values
      }
      variants(first: 50) {
        edges {
          node {
            id
            title
            price {
              amount
            }
            compareAtPrice {
              amount
            }
            availableForSale
          }
        }
      }
    }
  }
}
`;

export const variantCheckoutInfoById = `
query($ids: [ID!]!) @inContext(country: ${window.Shopify.country}){
  nodes(ids: $ids) {
    ...on ProductVariant {
      id
      title
      price {
        amount
      }
      compareAtPrice {
        amount
      }
      availableForSale
    }
  }
}
`;

export const productTagByVariantId = `
query($id: ID!) @inContext(country: ${window.Shopify.country}){
  node(id: $id) {
    ...on ProductVariant {
      product {
        id
        title
        handle
        vendor
        collections(first: 10) {
          edges {
            node {
              title
            }
          }
        }
        productType
        tags
        availableForSale
        priceRange {
          minVariantPrice {
            amount
          }
          maxVariantPrice {
            amount
          }
        }
        compareAtPriceRange {
          minVariantPrice {
            amount
          }
          maxVariantPrice {
            amount
          }
        }
        images(first: 1) {
          edges {
            node {
              src: url(transform: { maxWidth: 650 })
            }
          }
        }
        media(first: 1) {
          edges {
            cursor
            node {
              alt
              mediaContentType
              previewImage {
                altText
                src: url
              }
              ... on ExternalVideo {
                id
                embedUrl
              }
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
        }
        metafields(identifiers: [
          { namespace: "yotpo", key: "reviews_average" },
        ]) {
          key
          value
          namespace
        }
        variants(first: 50) {
          edges {
            node {
              id
              sku
              title
              price {
                amount
              }
              compareAtPrice {
                amount
              }
              availableForSale
              image {
                src: url
                altText
              }
            }
          }
        }
      }
    }
  }
}
`;

export const productAvailabilityByVariantId = `
query($id: ID!) @inContext(country: ${window.Shopify.country}){
  node(id: $id) {
    ...on ProductVariant {
      product {
        id
        title
        handle
        availableForSale
      }
    }
  }
}
`;

export const productLookDataByVariantId = `
query($id: ID!) @inContext(country: ${window.Shopify.country}){
  node(id: $id) {
    ...on ProductVariant {
      sku
      price {
        amount
      }
      compareAtPrice {
        amount
      }
      availableForSale
      image {
        src: url
        altText
      }
      shortDescription: metafield(namespace: "general", key: "short_description") {
        key
        value
      }

      product {
        id
        title
        handle
        vendor
        productType
        media(first: 1) {
          edges {
            cursor
            node {
              alt
              previewImage {
                altText
                src: url
              }
            }
          }
        }
        priceRange {
          minVariantPrice {
            amount
          }
          maxVariantPrice {
            amount
          }
        }
        compareAtPriceRange {
          minVariantPrice {
            amount
          }
          maxVariantPrice {
            amount
          }
        }
        collections(first: 10) {
          edges {
            node {
              title
            }
          }
        }
        tags
        availableForSale
        metafields(identifiers: [
          { namespace: "general", key: "cart_upsell_bundle" },
          { namespace: "cart_promo", key: "promo_text" },
          { namespace: "cart_promo", key: "link" },
          { namespace: "yotpo", key: "reviews_average" },
          { namespace: "general", key: "short_description" },
          { namespace: "card", key: "description" },
        ]) {
          key
          value
          namespace
        }
      }
    }
  }
}
`;

export const productById = `
query($id: ID!) @inContext(country: ${window.Shopify.country}){
  node(id: $id) {
    ...on Product {
      id
      title
      tags
      priceRange {
        minVariantPrice {
          amount
        }
        maxVariantPrice {
          amount
        }
      }
      compareAtPriceRange {
        minVariantPrice {
          amount
        }
        maxVariantPrice {
          amount
        }
      }
      images(first: 1) {
        edges {
          node {
            src: url(transform: { maxWidth: 650 })
          }
        }
      }
      media(first: 1) {
        edges {
          cursor
          node {
            alt
            mediaContentType
            previewImage {
              altText
              src: url
            }
            ... on ExternalVideo {
              id
              embedUrl
            }
          }
        }
      }
      variants(first: 1) {
        edges {
          node {
            id
            sku
            title
            price {
              amount
            }
            compareAtPrice {
              amount
            }
            availableForSale
            image {
              src: url
              altText
            }
          }
        }
      }
    }
  }
}
`;
